import { render, staticRenderFns } from "./addressValidate.vue?vue&type=template&id=5aed6859&scoped=true"
import script from "./addressValidate.vue?vue&type=script&lang=js"
export * from "./addressValidate.vue?vue&type=script&lang=js"
import style0 from "./addressValidate.vue?vue&type=style&index=0&id=5aed6859&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aed6859",
  null
  
)

export default component.exports